/* EVOQEN theme JS: scroll reveal, PDP gallery/variant/bundles, mobile menu */
(function(){
  function initReveal(){
    var els = document.querySelectorAll('.evq .rv:not(.in)');
    /* above-the-fold content shows immediately (no fade) so pages never look empty while loading */
    var vh = window.innerHeight || 800;
    els = Array.prototype.filter.call(els, function(e){
      var r = e.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0) { e.classList.add('now'); e.classList.add('in'); return false; }
      return true;
    });
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('in')}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {threshold:.12});
    els.forEach(function(el){ io.observe(el); });
  }
  document.addEventListener('DOMContentLoaded', initReveal);
  document.addEventListener('shopify:section:load', initReveal);
})();
function evqPdpImg(btn){
  var img = document.getElementById('evq-pdp-img');
  if (img) img.src = btn.dataset.full;
  document.querySelectorAll('.pdp-thumbs button').forEach(function(b){ b.classList.remove('on'); });
  btn.classList.add('on');
}
function evqBundle(el){
  document.querySelectorAll('.bundle').forEach(function(b){ b.classList.remove('on'); });
  el.classList.add('on');
  var q = document.getElementById('evq-qty');
  if (q) q.value = el.dataset.qty || 1;
}

/* hide option values (e.g. colors) that don't exist for the selected prior options (e.g. capacity) */
function evqFilterOptions(){
  if (!window.evqVariants || !window.evqVariants.length) return;
  var optCount = window.evqVariants[0].options.length;
  if (optCount < 2) return;
  for (var idx = 1; idx < optCount; idx++){
    var inputs = document.querySelectorAll('input[name="evq-option-' + (idx + 1) + '"]');
    if (!inputs.length) continue;
    var prior = [];
    for (var j = 0; j < idx; j++){
      var c = document.querySelector('input[name="evq-option-' + (j + 1) + '"]:checked');
      prior.push(c ? c.value : null);
    }
    inputs.forEach(function(inp){
      var ok = window.evqVariants.some(function(v){
        if (v.options[idx] !== inp.value) return false;
        for (var j = 0; j < idx; j++){
          if (prior[j] !== null && v.options[j] !== prior[j]) return false;
        }
        return true;
      });
      var lbl = document.querySelector('label[for="' + inp.id + '"]');
      if (lbl) lbl.style.display = ok ? '' : 'none';
    });
  }
}
document.addEventListener('DOMContentLoaded', evqFilterOptions);

function evqVariantChange(src){
  if (!window.evqVariants) return;
  var selected = [];
  var i = 1;
  while (true) {
    var checked = document.querySelector('input[name="evq-option-' + i + '"]:checked');
    if (!checked) break;
    selected.push(checked.value);
    i++;
  }
  var match = window.evqVariants.find(function(v){ return JSON.stringify(v.options) === JSON.stringify(selected); });
  /* sparse matrix: combo doesn't exist -> snap to nearest variant that has the value just picked */
  if (!match && src && src.name) {
    var chIdx = parseInt(src.name.split('-').pop(), 10) - 1;
    var chVal = src.value;
    match = window.evqVariants.find(function(v){ return v.options[chIdx] === chVal && v.available; }) ||
            window.evqVariants.find(function(v){ return v.options[chIdx] === chVal; });
    if (match) {
      match.options.forEach(function(val, idx){
        document.querySelectorAll('input[name="evq-option-' + (idx + 1) + '"]').forEach(function(inp){
          inp.checked = (inp.value === val);
        });
      });
      selected = match.options.slice();
    }
  }
  /* sync labels */
  selected.forEach(function(val, idx){
    var lbl = document.getElementById('evq-opt-' + (idx + 1));
    if (lbl) lbl.textContent = val;
  });
  if (match) {
    var idEl = document.getElementById('evq-variant-id');
    var priceEl = document.getElementById('evq-price');
    var compEl = document.getElementById('evq-compare');
    if (idEl) idEl.value = match.id;
    var wallets = document.getElementById('evq-pdp-wallets');
    if (wallets) wallets.hidden = !match.available;
    if (priceEl) priceEl.textContent = match.price;
    if (compEl && match.compare) compEl.textContent = match.compare;
    /* bundle row prices follow the selected variant */
    if (match.cents) {
      document.querySelectorAll('.bundles .bundle').forEach(function(b){
        var q = parseInt(b.dataset.qty || '1', 10);
        var bp = b.querySelector('.bp');
        if (bp) bp.textContent = '€' + (match.cents * q / 100).toFixed(2).replace('.', ',');
      });
    }
    evqFilterOptions();
    /* swap gallery image to the variant's bound image */
    if (match.image) {
      var img = document.getElementById('evq-pdp-img');
      if (img && img.src !== match.image) img.src = match.image;
      var thumbs = document.querySelectorAll('.pdp-thumbs button');
      thumbs.forEach(function(b){
        b.classList.toggle('on', b.dataset.full === match.image);
      });
    }
  }
}

/* ═══ EVOQEN cart drawer ═══ */
function evqMoney(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; }
function evqCartOpen(){
  evqCartRefresh().then(function(){
    document.getElementById('evq-cart-drawer').classList.add('open');
    document.getElementById('evq-cart-overlay').classList.add('open');
    document.body.classList.add('evq-drawer-lock');
  });
  return false;
}
function evqCartClose(){
  document.getElementById('evq-cart-drawer').classList.remove('open');
  document.getElementById('evq-cart-overlay').classList.remove('open');
  document.body.classList.remove('evq-drawer-lock');
}
document.addEventListener('keydown', function(e){ if(e.key === 'Escape') evqCartClose(); });
function evqCartRefresh(){
  return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
    var count = document.getElementById('evq-cart-count');
    var drCount = document.getElementById('evq-dr-count');
    var sub = document.getElementById('evq-dr-subtotal');
    if (count) count.textContent = cart.item_count;
    if (drCount) drCount.textContent = '(' + cart.item_count + ')';
    if (sub) sub.textContent = evqMoney(cart.items_subtotal_price);
    var drWallets = document.getElementById('evq-dr-wallets');
    if (drWallets) drWallets.hidden = !cart.items.length;
    var wrap = document.getElementById('evq-dr-items');
    if (!wrap) return cart;
    if (!cart.items.length){
      wrap.innerHTML = '<div class="dr-empty"><b style="font-family:var(--evq-disp);color:var(--evq-ink)">Dein Warenkorb ist leer.</b><p style="margin-top:8px;font-size:13px">Ultraflache Power wartet schon.</p></div>';
      return cart;
    }
    wrap.innerHTML = cart.items.map(function(item, i){
      var title = item.product_title.split(' — ')[0];
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_240x$1$2') : '';
      return '<div class="dr-item">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<div class="di-info"><b>' + title + '</b>' +
        (variant ? '<small>' + variant + '</small>' : '') +
        '<div class="qty-step">' +
          '<button type="button" onclick="evqDrawerQty(' + (i+1) + ',' + (item.quantity-1) + ')" aria-label="Weniger">−</button>' +
          '<input type="number" value="' + item.quantity + '" readonly>' +
          '<button type="button" onclick="evqDrawerQty(' + (i+1) + ',' + (item.quantity+1) + ')" aria-label="Mehr">+</button>' +
        '</div>' +
        '<button class="di-remove" type="button" onclick="evqDrawerQty(' + (i+1) + ',0)">Entfernen</button></div>' +
        '<div class="di-price">' + evqMoney(item.final_line_price) + '</div></div>';
    }).join('');
    return cart;
  });
}
function evqDrawerQty(line, qty){
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
  }).then(function(){ evqCartRefresh(); });
}
function evqQtyStep(btn, delta){
  var input = btn.parentElement.querySelector('input');
  input.value = Math.max(0, parseInt(input.value || '0', 10) + delta);
}
/* intercept PDP add-to-cart -> AJAX + open drawer */
document.addEventListener('submit', function(e){
  var form = e.target;
  if (form && form.id === 'evq-product-form'){
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var orig = btn ? btn.innerHTML : '';
    if (btn){ btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(){ evqCartOpen(); })
      .catch(function(){ window.location.href = '/cart'; })
      .finally(function(){ if(btn){ btn.disabled = false; btn.innerHTML = orig; } });
  }
});

/* footer accordion (mobile only via CSS) */
function evqFootToggle(el){
  if (window.innerWidth > 768) return;
  el.parentElement.classList.toggle('open');
}

/* mobile menu drawer */
function evqMenuOpen(){
  document.getElementById('evq-menu-drawer').classList.add('open');
  document.getElementById('evq-menu-overlay').classList.add('open');
  document.body.classList.add('evq-drawer-lock');
  return false;
}
function evqMenuClose(){
  document.getElementById('evq-menu-drawer').classList.remove('open');
  document.getElementById('evq-menu-overlay').classList.remove('open');
  if (!document.getElementById('evq-cart-drawer') || !document.getElementById('evq-cart-drawer').classList.contains('open')){
    document.body.classList.remove('evq-drawer-lock');
  }
}
document.addEventListener('keydown', function(e){ if(e.key === 'Escape') evqMenuClose(); });
document.addEventListener('click', function(e){
  var link = e.target.closest && e.target.closest('.evq-menu-drawer .md-links a');
  if (link) evqMenuClose();
});
